module.exports = __webpack_public_path__ + "img/3-4.9afd322e.svg";